import { Disc3 } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

export const CoverImage = ({ fileId, alt = "Portada", className }) => {
  const url = fileUrl(fileId);
  if (!url) {
    return (
      <div className={cn("flex items-center justify-center bg-muted text-muted-foreground rounded-md", className)}>
        <Disc3 className="h-1/2 w-1/2 opacity-40" />
      </div>
    );
  }
  return <img src={url} alt={alt} className={cn("object-cover rounded-md border border-border", className)} />;
};
